import * as React from "react";
import { trackEvent } from "../lib/analytics";

const BUYMEACOFFEE_URL = "https://buymeacoffee.com/suruleredotdev";

export const BuyMeCoffeeCTA: React.FC = () => {
  return (
    <div
      className={`transition-all duration-300 ease-in-out
        md:w-80 w-[calc(100%-1rem)]`}
      style={{ width: "max-content" }}
    >
    <a
      href={BUYMEACOFFEE_URL}
      onClick={() => trackEvent("support_click")}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-theme-color border border-theme-color p-2 px-3 hover:opacity-75 flex items-center gap-2"
      title="Support this project on Buy Me a Coffee"
      style={{ margin: "4px" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M17 8h1a4 4 0 1 1 0 8h-1" />
        <path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z" />
        <line x1="6" y1="2" x2="6" y2="4" />
        <line x1="10" y1="2" x2="10" y2="4" />
        <line x1="14" y1="2" x2="14" y2="4" />
      </svg>
      <span className="text-sm hidden md:inline">SUPPORT</span>
    </a>
    </div>
  );
};
